"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _colors = _interopRequireDefault(require("../theme/colors"));
/**
 * @param props
 * @returns {*}
 * @constructor
 */
var OutlinedBox = function OutlinedBox(props) {
  var classes = props.classes,
    children = props.children,
    customStyle = props.customStyle,
    id = props.id,
    testid = props.testid;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id || testid,
    className: "".concat(classes.outlinedBox, " ").concat(customStyle)
  }, children);
};

/**
 * @param theme
 */
var styles = function styles(theme) {
  return {
    outlinedBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      minHeight: '56px',
      margin: "0",
      marginTop: '16px',
      marginBottom: '8px',
      padding: "0",
      paddingRight: '5px',
      paddingLeft: '5px',
      transition: "padding-left 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,border-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,border-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "4px",
      borderColor: _colors["default"].muiBorderGrey,
      '&:hover': {
        borderColor: _colors["default"].darkBlue
        // borderColor: colors.skyBlue
      },
      '&:focus': {
        borderColor: _colors["default"].mediumDarkBlue
      },
      '&:focus-within': {
        borderColor: _colors["default"].skyBlue,
        backgroundColor: _colors["default"].lightGrey
      }
    }
  };
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(OutlinedBox);